import { Box, Button, Grid } from "@mui/material";
import RightViewLayout from "../../components/RighViewLayout";
import CustomInput from "../../components/CustomInput";
import { REACT_LOCATION } from "@/router/ReactEndPoints";
import { useEffect, useState } from "react";
import {
  editOutletType,
  findOutletTypeByIdOrCode,
} from "@/services/OutletTypeService";
import CommonUtil from "@/util/CommonUtils";
import { t } from "i18next";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";

export default function EditOutletType1() {
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();

  const [payload, setPayload] = useState({
    id: "",
    name: "",
    code: "",
  });

  const [error, setError] = useState({
    name: "",
    code: "",
  });

  useEffect(() => {
    console.log("params:", params);
      findOutletTypeByIdOrCode(params.id).then((res) => {
        if (res.data.code === "LVLI0000") {
          setPayload({
            ...payload,
            ...res.data.data,
          });
        }
      });
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      ...error,
      [name]: "",
      common: "",
    });
  };

  const validateForm = () => {
    if (CommonUtil.isEmptyString(payload.name)) {
      setError({
        ...error,
        name: t("LVL0001"),
      });
      return;
    }
    if (CommonUtil.isEmptyString(payload.code)) {
      setError({
        ...error,
        code: t("LVL0001"),
      });
      return;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      editOutletType(payload.id, { ...payload }).then((response) => {
        if (response.data.code === "LVLI0005") {
          enqueueSnackbar(response.data.message, {
            variant: "success",
            anchorOrigin: {
              horizontal: "center",
              vertical: "top",
            },
            style: {
              marginTop: "300px",
            },
          });
          navigate(REACT_LOCATION);
          return;
        }

        switch (response.data.code) {
          case "LVLE0007":
            setError({
              ...error,
              name: response.data.message,
            });
            break;
          case "LVLE0008":
            setError({
              ...error,
              code: response.data.message,
            });
            break;
          case "LVLE0024":
            setError({
              ...error,
              name: response.data.message,
            });
            break;
          case "LVLE0025":
            setError({
              ...error,
              code: response.data.message,
            });
            break;
          default:
            console.log("");
        }
      });
    }
  };

  return (
    <RightViewLayout
      id="editoutlettypeback"
      navigateBack={REACT_LOCATION}
      title={t("LVLLOC0048")}
    >
      <Grid container spacing={2} px={2}>
        <Grid item md={6} xs={12}>
          <CustomInput
            id={"EditOutletType-CustomInput-1"}
            error={error.name}
            required
            label={t("LVLLOC0034")}
            size="small"
            name="name"
            value={payload.name}
            inputProps={{
              maxLength: 100,
            }}
            helperText={error.name}
            validation="alpha-numeric"
            handleChange={handleChange}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <CustomInput
            id={"EditOutletType-CustomInput-2"}
            required
            label={t("LVLLOC0035")}
            size="small"
            name="code"
            error={error.code}
            value={payload.code}
            inputProps={{
              maxLength: 100,
            }}
            helperText={error.code}
            validation="alpha-numeric"
            handleChange={handleChange}
            disabled
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} px={2} flexDirection={"row-reverse"}>
        <Grid item md={6} xs={12}>
          <Box display={"flex"} justifyContent={"flex-end"}>
            <Box item>
              <Button
                id="editoutlettypelistback"
                className="text-transform-none"
                variant="outlined"
                onClick={() => navigate(REACT_LOCATION)}
                size="large"
              >
                {t("LVLLOC0037")}
              </Button>
            </Box>
            <Box item pl={2}>
              <Button
                id="EditOutletType1"
                variant="contained"
                size="large"
                className="text-transform-none"
                onClick={(e) => handleSubmit(e)}
              >
                {t("LVLLOC0036")}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </RightViewLayout>
  );
}
